module.exports = __webpack_public_path__ + "static/media/Piercing-ear-dillatation.1bcee2b9.png";